
import { Agent } from "@/models/agent";
import { supabase } from "@/integrations/supabase/client";

export const fetchAgentData = async (agentId: string): Promise<Agent | null> => {
  try {
    const { data: agentData, error } = await supabase
      .from('agents')
      .select('*')
      .eq('id', agentId)
      .single();
    
    if (error) {
      console.error('Error fetching agent data:', error);
      throw error;
    }
    
    // Map database model to app model
    const agent: Agent = {
      id: agentData.id,
      name: agentData.name,
      description: agentData.description,
      category: agentData.category,
      tags: agentData.tags || [],
      // Map any pricing model values to our supported "free" | "paid" values
      pricingModel: agentData.pricing_model === "free" ? "free" : "paid",
      // Safely handle price using type assertion since it might not be in the type definition
      price: (agentData as any).price !== undefined ? (agentData as any).price : undefined,
      owner_id: agentData.owner_id,
      fullDescription: agentData.full_description,
      features: agentData.features || [],
      useCases: agentData.use_cases || [],
      requirements: agentData.requirements,
      version: agentData.version,
      license: agentData.license,
      fileUrl: agentData.file_url,
      isPublic: agentData.is_public,
      downloads: agentData.downloads,
      revenue: agentData.revenue,
      createdAt: new Date(agentData.created_at),
      updatedAt: agentData.updated_at ? new Date(agentData.updated_at) : undefined,
      // Handle custom code and prompt template with type assertion and default values
      customCode: (agentData as any).custom_code !== undefined ? String((agentData as any).custom_code) : "",
      promptTemplate: (agentData as any).prompt_template !== undefined ? String((agentData as any).prompt_template) : ""
    };
    
    // Perform any additional processing here if needed
    
    return agent;
  } catch (error) {
    console.error('Error in fetchAgentData:', error);
    throw error;
  }
};
